import { combineReducers } from 'redux';

import archiveActiveEot from './archive-active-eot';
import confirmation from './confirmation';
import costCenterNameCheck from './cost-center-name-check';
import licenses from './license';
import licenseSearch from './license-search';
import licenseViewMode from './license-view-mode';
import licenseRequest from './licenseRequest';
import suffixes from './pending-suffix';
import searchStatus from './search-status';
import selectedUserCostCenters from './selected-user-cost-centers';
import userFieldError from './user-field-error';
import users from './users';
import productFeatures from './product-features';
import seatFeatures from './seat-features';
import usersRequest from './users-request';

export default combineReducers({
  archiveActiveEot,
  costCenterNameCheck,
  licenses,
  licenseSearch,
  licenseViewMode,
  suffixes,
  confirmation,
  licenseRequest,
  usersRequest,
  selectedUserCostCenters,
  userFieldError,
  users,
  productFeatures,
  seatFeatures,
  searchStatus,
});
